import { atom } from "jotai";
import { fileValuesSelector } from "./uppyAtoms";

export const chatInputAtom = atom('');

/**
 * 派生atom，用于判断是否有内容可发送
 * 当输入框有内容或有文件时返回true
 */
export const hasContentAtom = atom((get) => {
    const input = get(chatInputAtom);
    const files = get(fileValuesSelector);
    return input.trim().length > 0 || files.length > 0;
});

// ============ 语音模式相关状态 ============

/**
 * 语音模式状态
 * true: 语音模式, false: 文本模式
 */
export const voiceModeAtom = atom(false);

/**
 * 语音录制状态
 * true: 正在录音, false: 未录音
 */
export const isVoiceRecordingAtom = atom(false);

/**
 * 语音手势状态
 * normal: 正常状态
 * dragging-cancel: 拖拽到取消区域
 * dragging-edit: 拖拽到编辑区域
 */
export type VoiceGestureState = 'normal' | 'dragging-cancel' | 'dragging-edit';
export const voiceGestureStateAtom = atom<VoiceGestureState>('normal');

// ============ TTS 相关状态 ============

/**
 * 自动朗读回复开关状态
 * true: 开启自动朗读, false: 关闭自动朗读
 */
export const autoTTSEnabledAtom = atom(false);

/**
 * TTS 播放状态
 * true: 正在朗读, false: 未朗读
 */
export const ttsPlayingAtom = atom(false);

/**
 * 当前播放的音频对象
 * 用于控制音频播放和停止
 */
export const currentTTSAudioAtom = atom<HTMLAudioElement | null>(null);

// ============ STT 相关状态 ============

/**
 * STT 处理状态
 * true: 正在处理STT转录, false: 未处理
 */
export const sttProcessingAtom = atom(false);

// ============ 键盘状态相关 ============

/**
 * 聊天输入框焦点状态
 * true: 输入框有焦点（键盘显示）, false: 输入框无焦点（键盘隐藏）
 */
export const chatInputFocusedAtom = atom(false);

// ============ 实体自动完成相关 ============

/**
 * 实体自动完成状态
 */
export interface EntityAutocompleteState {
  isOpen: boolean;
  searchQuery: string;
  selectedIndex: number;
  triggerPosition: number; // @ 字符在文本中的位置
  cursorPosition: number; // 当前光标位置
}

/**
 * 实体自动完成状态原子
 */
export const entityAutocompleteAtom = atom<EntityAutocompleteState>({
  isOpen: false,
  searchQuery: '',
  selectedIndex: 0,
  triggerPosition: -1,
  cursorPosition: 0
});